var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.img)?_c('div',{on:{"click":_vm.methodHiddenPic}},[_c('div',{staticClass:"enlargeImg"},[_c('img',{attrs:{"src":_vm.img}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }